import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';

const SessionContext = createContext();

export const SessionProvider = ({ children }) => {
  const [selectedSession, setSelectedSession] = useState(localStorage.getItem('selectedSession') || 'all');
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSessions();
  }, []);

  const fetchSessions = async () => {
    try {
      const response = await api.get('/academic-sessions');
      setSessions(response.data);
      if (response.data.length > 0 && selectedSession === 'all' && !localStorage.getItem('selectedSession')) {
        // Option: set default to latest session if preferred, but user said "if all=session is selected then while saving we will ask to enter session"
        // So we keep 'all' as default if they haven't picked one.
      }
    } catch (error) {
      console.error('Failed to fetch sessions:', error);
    } finally {
      setLoading(false);
    }
  };

  const updateSession = (session) => {
    setSelectedSession(session);
    localStorage.setItem('selectedSession', session);
  };

  return (
    <SessionContext.Provider value={{ selectedSession, sessions, updateSession, fetchSessions, loading }}>
      {children}
    </SessionContext.Provider>
  );
};

export const useSession = () => useContext(SessionContext);
